import MyCollapse from "../../components/MyCollapse";

const AboutUs03 = () => {
  const content = [
    {
      value: 1,
      title: "언제 출산을 해야 할까요?",
      content: () => (
        <div className="collapse-content">
          <div className="ac_text ac1-2">
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/03-01.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p>
                {`CDH 아기의 출산은 철저한 계획을 가지고 진행되어야 합니다. 출산 예정일은 아기의 상태에 따라 결정됩니다만 모든 신생아와 마찬가지로 조산은 가능한 피해야 합니다.
                                특히, 의학적이지 않은 이유로 인위적으로 분만 일정을 앞당기는 것은 바람직하지 않습니다.
                                다행히 인큐베이터 치료가 필요할 정도의 극소저체중출생아 (<1500g) 또는 초극소저출생체중아 (<1000g)로 출생하는 조산이 아니라면 적절한 치료로 만삭아와 유사한 수준의 생존율을 기대할 수 있습니다. 다만 폐형성부전이 심한 일부 아기들 중 임신나이 34주 이전에 태어날 경우 ECMO 시술이 불가능하거나 시술 관련 합병증이 증가할 수 있습니다.`}
              </p>
            </div>
          </div>
        </div>
      ),
    },
    {
      value: 2,
      title: "신생아 중환자실 치료는 어떻게 진행되나요?",
      content: () => (
        <div className="collapse-content">
          <div
            className="ac_text ac1-2"
            style={{
              marginBottom: 15,
            }}
          >
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/03-02.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p style={{ color: "#000" }}>
                아기가 태어난 후 신생아 중환자실에서의 치료 여정은 크게 4단계로
                나눌 수 있습니다.
              </p>
            </div>
          </div>
          <div className="ac_text ac3-2">
            <div className="img">
              <img src="/assets/img/ac5-8.png" alt="" className="pc" />
              <img src="/assets/img/mac5-8.png" alt="" className="mob" />
            </div>
            {/* <h5>[선천성 횡격막 탈장의 흉부 X선 사진과 신생아 중환자실 여정]</h5> */}
            <dl>
              <dt>01</dt>
              <dd>
                <h2>초기 안정화</h2>
                <p>
                  인공호흡기와 심혈관계 보조 약물이 CDH 환자의 초기 안정화에
                  가장 중요한 치료입니다. 출산 직후 아기는 양수에서 공기 중으로
                  나오는 급격한 변화에 적응하면서 스스로 호흡을 할 수 있어야
                  합니다. 하지만 CDH 아기 대부분은 스스로의 호흡 만으로 충분한
                  산소 공급이 어렵습니다. 따라서 거의 대부분의 CDH는 출생직후
                  기관내 삽관과 인공호흡기 치료가 필요합니다.
                </p>
                <p>
                  신생아 의사는 아기의 호흡상태를 지속적으로 모니터링하며 산소
                  농도와 인공호흡기 세팅을 조정하게 됩니다. 이 과정에서 대부분
                  동맥 도관을 삽입하여 혈압을 실시간으로 모니터링 할 뿐 아니라
                  동맥혈 가스검사를 시행하여 인공 호흡기 세팅 결정에 도움을 받게
                  됩니다. 심혈관계 보조 약물로 가장 중요한 것은 폐고혈압 치료와
                  강심제입니다. 또한 아기는 횡격막 교정술 전까지는 입으로 먹을
                  수 없으므로 영양 공급을 위해 정맥 영양을 받게 됩니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>02</dt>
              <dd>
                <h2> 횡격막 복원술</h2>
                <p>
                  횡격막 탈장 복원술은 횡격막 결손 부 구멍을 통해 흉강으로
                  올라간 장기를 원래의 위치인 복강으로 다시 되돌려주는 중요한
                  과정입니다. 수술은 출생 직후 보다는 아기의 상태가 어느 정도
                  안정되었을 때 시행하는 것이 원칙이며 그 시기는 신생아 의사와
                  소아 외과 의사의 협의를 통해 결정됩니다. 아기 상태가 비교적
                  안정적이라면 생후 수 일 이내에도 시행할 수 있지만 아기 상태가
                  불안정 하다면 생후 1주 혹은 수 주 이후로 수술을 미루게 됩니다.
                  복원술을 하더라도 바로 인공 호흡기를 떼거나 수유가 가능하지는
                  않습니다. 아기의 폐가 펴지는 과정, 장의 가스 음영이 정상적으로
                  돌아오는 과정 등을 면밀하게 관찰해야 합니다. 태아기 오랜 기간
                  비정상적인 상태에 있던 폐 기능과 장기 기능이 회복되기까지는
                  상당한 기다림의 시간이 필요하다는 것을 기억해 주세요.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>03</dt>
              <dd>
                <h2> 인공호흡기 제거와 안정기 치료</h2>
                <p>
                  수술 후 아기가 자발 호흡을 할 수 있을 정도로 폐 기능이
                  회복되었다고 판단되면 신생아 의사는 인공호흡기를 제거하고 발관
                  (기관내관 제거술)을 진행합니다. 발관 후에도 비강 양압 환기나
                  산소 치료 등 호흡 보조가 필요할 수 있습니다. 생후 초기에
                  문제가 되었던 폐 고혈압은 생후 2-3주가 되면 절반 정도의
                  아기들에서 회복이 됩니다. 그러나 일부 환자들은 수술을 마치고
                  인공호흡기를 뗀 후에도 폐고혈압이 지속됩니다.
                </p>
                <p>
                  안타깝게도 일부 아기들은 성공적인 횡격막 복원술 이후에도
                  폐고혈압 또는 만성폐질환의 문제로 장기간 인공호흡기 치료가
                  필요한 경우가 있습니다. 이런 경우 아기의 장기적 발달과 성장을
                  지원하기 위해 기관절개술과 가정용 인공호흡기 등 특별한 치료를
                  계획하기도 합니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>04</dt>
              <dd>
                <h2>수유 진행</h2>
                <p>
                  횡격막 복원술이 완료되었다면 아기는 원칙적으로 장으로 영양
                  공급을 할 수 있는 상태가 된 것입니다. 다만 신생아 의사는
                  아기의 호흡상태, 장내 가스 양상 등 여러 상황을 판단하여 수유
                  결정을 하게 됩니다. 대개 처음에는 경관 (코 또는 입을 통해 위에
                  거치한 관)을 통해 영양을 공급하다가 기관지(내)관 발관 후에는
                  직접 입으로 젖병을 빠는 수유 연습을 진행합니다. 수유는 모유로
                  시작하고 진행하는 것이 원칙이며 수유량과 속도는 아기의 소화
                  기능과 호흡상태를 고려하여 단계적으로 진행됩니다.
                </p>
              </dd>
            </dl>
            <br />
            <h6>
              이 4단계가 순조롭게 진행되고, 아기가 스스로 호흡하며 충분한 영양을
              섭취할 수 있을 때, 의료진은 퇴원을 고려하게 됩니다. 퇴원 후에도
              아기는 지속적인 외래 관찰이 필요하며, 폐와 심장, 소화기관의 기능을
              모니터링하는 추가 검사가 진행될 수 있습니다.
            </h6>
          </div>
        </div>
      ),
    },
    {
      value: 3,
      title: "폐고혈압이란 무엇이고 어떤 치료가 필요한가요?",
      content: () => (
        <div className="collapse-content">
          <div
            className="ac_text ac1-2"
            style={{
              marginBottom: 15,
            }}
          >
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/03-03.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p style={{ color: "#000" }}>
                CDH는 태아 발달 중에 횡격막이 제대로 형성되지 않아 복부 장기들이
                흉강으로 들어가면서 폐의 발달을 방해하는 질환입니다. 이로 인해
                폐가 정상적으로 성장하지 못하고, 폐혈관의 발달도 저해되어
                폐고혈압이 발생할 수 있습니다. 폐고혈압은 폐혈관 저항이 높아져서
                혈액이 폐로 충분히 공급되지 못하고 산소화가 어려워지는
                상태입니다. 폐고혈압 치료의 목표는 폐혈관 저항을 낮추고 산소화를
                개선하는 데 있습니다. 이를 위해 다양한 약물과 치료법이
                사용됩니다.
              </p>
            </div>
          </div>
          <div className="ac_text ac3-3">
            <dl>
              <dt>01</dt>
              <dd>
                <h2>일산화질소 흡입 (iNO, Inhaled Nitric Oxide)</h2>
                <p>
                  폐혈관을 확장시켜 폐혈류를 증가시키는 역할을 합니다. 특히
                  산소화가 저하된 신생아에서 자주 사용됩니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>02</dt>
              <dd>
                <h2>
                  고빈도 진동 환기(HFOV, High-Frequency Oscillatory Ventilation)
                </h2>
                <p>
                  전통적인 기계 환기보다 폐를 보호하고 이산화탄소 배출을
                  용이하게 하여 폐고혈압을 줄이는 데 도움을 줍니다. 이 기법은
                  약물이 아닌 기계적 방법이지만 폐고혈압 관리에 중요한 역할을
                  합니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>03</dt>
              <dd>
                <h2>기타 폐혈관 평활근 이완 약물 </h2>
                <p>
                  PDE5 억제제 (예: Sildenafil), 엔도셀린 수용체 억제제 (예:
                  Bosentan), 프로스타사이클린 제제 (예: Treprostinil, Iloprost)
                  등의 약물이 있습니다.{" "}
                </p>
              </dd>
            </dl>
            <dl>
              <dt>04</dt>
              <dd>
                <h2>
                  ECMO (체외막 산소요법, Extracorporeal Membrane Oxygenation)
                </h2>
                <p>
                  약물이나 기계적 환기가 충분하지 않을 경우, ECMO를 사용하여
                  신생아의 폐와 심장 기능을 대신해 산소화를 유지합니다.
                </p>
              </dd>
            </dl>
          </div>
        </div>
      ),
    },
    {
      value: 4,
      title:
        "체외막 산소요법(extracorporeal membrane oxygenation, ECMO)란 무엇인가요?",
      content: () => (
        <div className="collapse-content">
          <div
            className="ac_text ac1-2"
            style={{
              marginBottom: 10,
            }}
          >
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/03-04.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <dl style={{ paddingLeft: 0, marginTop: 0 }}>
                <dd>
                  <p>
                    체외막 산소요법 (ECMO)은 폐와 심장의 기능을 대신하여 산소를
                    공급하고 이산화탄소를 제거하는 인공 생명 유지 장치입니다.
                    CDH 아기들은 심각한 호흡 부전, 폐고혈압, 심장 기능 감소를
                    가질 수 있으며 이 때 ECMO는 아기를 교정 수술까지 안정시키기
                    위한 중요한 징검다리 역할을 합니다. 대부분의 경우는 출생
                    24시간 이내에 ECMO를 적용하게 되지만 일부는 수 일이 지난
                    후에도 아기 상태가 악화되어 ECMO를 적용하게 되는 경우도
                    있습니다.
                  </p>
                </dd>
              </dl>
            </div>
            <div className="top">
          <dl style={{ paddingLeft: 0, marginTop: 0 ,marginBottom: 20 }}>
          <dd>
            <p>
              신생아에서 ECMO를 시작하기 위해서는 심장 또는 심장 주변 큰 혈관에
              도관을 삽입하는 수술이 필요합니다. ECMO는 혈액을 체외로 빼내어
              기계가 산소를 공급하고 이산화탄소를 제거한 후 펌프를 통해 다시
              체내로 넣어주는 방식으로 작동합니다. ECMO 적용 중에는 도관 유지를
              위해 보통 진정제와 근육이완제를 투여하여 아기의 절대 안정을
              확보합니다. 체외로 나온 혈액이 도관과 기계를 통과하는 동안 굳지
              않도록 항응고제 (또는 혈전 방지제)가 투여됩니다. 항응고제는 보통
              정맥주사로 투여되며 혈액응고 정도를 확인할 수 있는 몇 가지 혈액
              검사를 시행하면서 용량을조정하게 됩니다. 그러나 이러한 노력에도
              불구하고 ECMO치료는 출혈 또는 혈전의 위험을 증가시킬 수 있습니다.
              간혹 뇌출혈, 대량 위장 출혈 같은 심각한 합병증을 일으킬 수도
              있습니다.{" "}
            </p>
            <p>
              ECMO가 필요한 중증 CDH 환자에서 횡격막 교정술 시기에 대해서는 아직
              논란이 있습니다. 에크모 적용 직후 안정을 찾은 상태에서 가능한 빨리
              횡격막 교정술을 시행하여 수술 미시행의 위험성을 줄이고 빠른 장기
              기능의 회복을 기대하는 것이 좋다는 의견이 있습니다. 반면 ECMO를
              중단한 후 항응고제로 인한 수술 관련 출혈 위험성을 최소화하는 것이
              좋다는 의견도 있습니다.{" "}
            </p>
            <p>
              심한 폐저형성이 있는 일부 아기들은 ECMO 치료에도 불구하고 회복이
              충분하지 않은 경우가 있습니다. 언제까지 ECMO를 시행해야 하는지에
              대해서는 논란이 있지만 대략 4주 이상 ECMO에 의존하게 되는 경우라면
              생존은 어렵다고 판단합니다. 이럴 경우 ECMO는 치료를 위한
              징검다리보다는 연명치료의 도구가 됩니다. 의료진은 부모님과
              상의하여 ECMO 치료를 중단하는 결정을 내려야 할 수 있습니다.
            </p>
            </dd>
              </dl>
           
          </div>
          <div className="img" style={{display:"block"}}>
              <img src="/assets/img/ac5-9.png" alt="" />
            </div>
            <h6>
              [아기의 심장에서 혈액을 빼내어 산소와 이산화탄소 교환 후 다시
              아기의 목동맥을 통해 전신 순환으로 들어가게 함]
            </h6>
          </div>
        </div>
      ),
    },
    {
      value: 5,
      title: "퇴원할 때는 어떤 교육을 받게 되나요?",
      content: () => (
        <div className="collapse-content">
          <div
            className="ac_text ac1-2"
            style={{
              marginBottom: 15,
            }}
          >
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/03-05.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p style={{ color: "#000" }}>
                퇴원할 때는 아기의 상태와 필요한 장치에 따라 다음과 같은 교육을
                받게 됩니다.
              </p>
            </div>
          </div>
          <div className="ac_text ac3-2">
            <dl>
              <dt>01</dt>
              <dd>
                <h2>모니터, 산소 교육</h2>
                <p>
                  호흡 보조 장치 등이 필요한 경우, 퇴원 후에도 산소포화도나
                  심박수 모니터링이 필요하기 때문에 모니터 작동법을 숙지합니다.
                  산소 보조가 지속적으로 필요한 경우, 산소 농도 조절 기기 관리
                  요령에 대해 교육을 받습니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>02</dt>
              <dd>
                <h2>수유 교육</h2>
                <p>
                  경구 수유와 튜브 수유 방법을 배우고, 의사가 권장한 수유량과
                  빈도에 맞춰 수유량을 조절하는 방법을 익힙니다.
                </p>
              </dd>
            </dl>
            <dl>
              <dt>03</dt>
              <dd>
                <h2>약물 복용</h2>
                <p>
                  처방받은 약물을 정해진 시간과 용량에 따라 복용하며, 약물의
                  부작용과 대처 방법에 대해 숙지합니다.{" "}
                </p>
              </dd>
            </dl>
          </div>
        </div>
      ),
    },
    {
      value: 6,
      title: "언제 병원에 와야 하나요?",
      content: () => (
        <div className="collapse-content">
          <div
            className="ac_text ac1-2"
            style={{
              marginBottom: 15,
            }}
          >
            <div className="top">
              <span>
                <img
                  src="/assets/img/icon/03-06.png"
                  style={{ width: 100, minWidth: 100 }}
                  alt=""
                />
              </span>
              <p style={{ color: "#000" }}>
                퇴원 후에는 담당 의료진의 지침에 따라 정기적인 외래 방문이
                필요합니다.
                <br />
                아래와 같은 증상이 나타난다면 즉시 병원을 방문해야 합니다.
              </p>
            </div>
          </div>
          <div className="ac_text ac3-2">
            <dl>
              <dt>01</dt>
              <dd>
                <h2>호흡 곤란</h2>
                <p>숨이 가빠지거나 입술, 손발이 파랗게 변하는 청색증 등</p>
              </dd>
            </dl>
            <dl>
              <dt>02</dt>
              <dd>
                <h2>수유 문제</h2>
                <p>
                  지속적인 구토나 식이 장애, 체중 감소 등으로 인해 수유가 어려울
                  때
                </p>
              </dd>
            </dl>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="acco">
      <MyCollapse data={content} />

      <div className="ac_text">
        <div className="info_text">
          <p>
            아기와 보호자가 신생아 중환자실에서 치료를 겪는 여정은 험난한 산을
            넘는 것과 같습니다. 그러나 산부인과, 신생아과, 소아심장과, 소아외과
            등 다양한 분과 의료진 상호 간의 협력 그리고 전문적이고 세심한
            간호팀의 지원은 아기와 모든 산을 넘어 건강한 모습으로 엄마 아빠의 품
            안으로 돌아갈 수 있도록 하는 큰 힘이 될 것입니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs03;
